import { Box, Text, styled, alpha } from '@ltvco/refresh-lib/theme';

export const SwitchContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const SwitchTrack = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})<{ isChecked: boolean }>(({ theme, isChecked }) => ({
  position: 'relative',
  width: '56px',
  height: '28px',
  borderRadius: '100px',
  backgroundColor: isChecked
    ? theme.palette.success.main
    : theme.palette.grey[400],
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '4px',
  paddingRight: '4px',
}));

export const SwitchKnob = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})<{ isChecked: boolean }>(({ theme, isChecked }) => ({
  position: 'absolute',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[50],
  boxShadow: `0px 2px 4px ${alpha(theme.palette.common.black, 0.2)}`,
  transition: 'left 0.2s ease-in-out',
  left: isChecked ? '28px' : '4px',
}));

export const SwitchLabel = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})<{ isChecked: boolean }>(({ theme, isChecked }) => ({
  position: 'absolute',
  fontSize: '12px',
  fontWeight: 400,
  color: theme.palette.common.white,
  userSelect: 'none',
  left: isChecked ? '6px' : 'auto',
  right: isChecked ? 'auto' : '6px',
}));

export const LabelText = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  userSelect: 'none',
}));
